export default __webpack_public_path__ + "static/media/19.b8f2d238.jpg";